import { render } from "./Scenarios.vue?vue&type=template&id=20be4695&scoped=true"
import script from "./Scenarios.vue?vue&type=script&lang=js"
export * from "./Scenarios.vue?vue&type=script&lang=js"

import "./Scenarios.vue?vue&type=style&index=0&id=20be4695&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20be4695"]])

export default __exports__